import { Form, Input, Modal, Row, Space } from "antd";
import React, { useState } from "react";
import AtomPrimaryButton from "../../button/primary-button";
import AtomSecondaryButton from "../../button/secondary-button";

const UpdatePasswordModal = ({ open, setOpen, isSubmit, onFinish }) => {
  const [input, setInput] = useState({
    old_password: "",
    new_password: "",
    password_confirmation: "",
  });

  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const onSubmit = (values) => {
    onFinish(values);
    setInput({
      ...input,
      old_password: "",
      new_password: "",
      password_confirmation: "",
    });
  };

  return (
    <Modal
      title="Edit Password"
      centered
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
    >
      <Form
        name="update-email"
        layout="vertical"
        onFinish={() => onSubmit(input)}
        autoComplete="off"
      >
        <Form.Item
          style={{
            fontWeight: 500,
          }}
          label="Old Password"
          // name="old_password"
          rules={[
            {
              required: true,
              message: "Please input your old password!",
            },
          ]}
        >
          <Input.Password
            size="large"
            name="old_password"
            placeholder="Input your old password"
            value={input.old_password}
            onChange={(e) => handleChange(e)}
          />
        </Form.Item>

        <Form.Item
          style={{
            fontWeight: 500,
          }}
          label="New Password"
          // name="new_password"
          rules={[
            {
              required: true,
              message: "Please input your new password!",
            },
          ]}
        >
          <Input.Password
            size="large"
            name="new_password"
            placeholder="Input your new password"
            value={input.new_password}
            onChange={(e) => handleChange(e)}
          />
        </Form.Item>

        <Form.Item
          style={{
            fontWeight: 500,
          }}
          label="Confirm New Password"
          // name="password_confirmation"
          rules={[
            {
              required: true,
              message: "Please confirm your new password!",
            },
          ]}
        >
          <Input.Password
            size="large"
            name="password_confirmation"
            placeholder="Confirm your new password"
            value={input.password_confirmation}
            onChange={(e) => handleChange(e)}
          />
        </Form.Item>

        <Row justify="center">
          <Space size="middle">
            <AtomPrimaryButton
              loading={isSubmit}
              disabled={
                !input.old_password ||
                !input.new_password ||
                !input.password_confirmation ||
                input.new_password !== input.password_confirmation
              }
              htmlType="submit"
            >
              Save Changes
            </AtomPrimaryButton>

            <AtomSecondaryButton onClick={() => setOpen(false)}>
              Cancel
            </AtomSecondaryButton>
          </Space>
        </Row>
      </Form>
    </Modal>
  );
};

export default UpdatePasswordModal;
